import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  standalone: false,
  name: 'i18nDate'
})
export class I18nDatePipe implements PipeTransform {

  public transform(date: string | Date, format = '') {
    return moment(date).format(format);
  }

}
